



























































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Menu from '../../../api/v2/models/menu'
import { ROUTER_NAME } from '../../router'
import { examState } from '../../stores/exam'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'
import { LETTER_FORMAT } from '../../utils/constants'

@Component({
  components: {}
})
export default class HeaderLeftMenuWeb extends Vue {
    @Prop({required: true}) value: boolean
    LETTER_FORMAT = LETTER_FORMAT
    ROUTER_NAME = ROUTER_NAME

  mounted() {
      console.log(this.$route)
  }

    get schoolSetting() {
        return headerState.schoolSetting
    }

    get user() {
        return userState.user
    }

    get untestCount() {
        return examState.listRecommendationExam.untestCount
    }

    get drawer(){
        return this.value
    }

    set drawer(val: boolean){
        this.$emit('input', val)
    }

    getVisiable(type: string) {
      if (!this.schoolSetting || !this.schoolSetting.classroomMenus) {
        return false
      }
      return this.schoolSetting.classroomMenus.find(item => item.kbn == type).visibility
    }

    goToHome(){
      this.$router.push({
        name: ROUTER_NAME.HOME,
      })
    }

    created() {
        headerState.getSchoolSetting()
    }

    logout() {
      // Clear all cart-related data from sessionStorage
      sessionStorage.removeItem('cart');
      sessionStorage.removeItem('checkout_cart');

      window.location.href = '/users/sign_out'
    }

  goToPath(path) {
    window.location.href = path
  }
}
